import styled from 'styled-components'
import {ContentContainer} from '@components/lib'
import {Link} from 'react-router-dom'

export const Wrapper = styled.div`
  background: ${({theme}) => theme.colors.headerBackground};
  width: 100%;
  height: ${({theme}) => theme.sizes.navigationHeight};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  border-bottom: 1px solid ${({theme}) => theme.colors.border};
  display: flex;
`

export const Logospan = styled.div``

export const LinksWrapper = styled.div`
  display: flex;
`

export const OtherActionsWrapper = styled.div`
  display: flex;
`

export const DepositBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 25px;

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    margin-bottom: 30px;
    padding: 0;
  }
`

export const Container = styled(ContentContainer)`
  flex: 1;
  display: flex;
  justify-content: space-between;
`

export const Logo = styled.img`
  width: 80px;
  height: auto;
`

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: 20px;

  ${({theme}) => theme.breakpoints.down('mobileL')} {
    margin-right: 0;
  }
`

export const ItemsWrapper = styled.div`
  display: flex;

  ${({theme}) => theme.breakpoints.down('tabletL')} {
    display: none;
  }
`

export const LanguagesDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
`

export const Item = styled(Link)`
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  height: 100%;
  margin: 0 5px;
  transition-duration: 150ms;
  color: ${({theme}) => theme.colors.textThird};
  fill: currentColor;

  &:hover {
    text-decoration: none;
    cursor: pointer;
    color: ${({theme}) => theme.colors.textFourth};
    fill: currentColor;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${({theme}) => theme.colors.textFourth};
    opacity: 0;
    transition-duration: 0.25s;
    transform: translateY(100%);
  }

  &.active {
    &:after {
      opacity: 1;
      transform: translateY(0);
    }
    color: ${({theme}) => theme.colors.textFourth};
    fill: ${({theme}) => theme.colors.textFourth};
  }
  ${({$isActive, theme}) =>
    $isActive && {
      color: theme.colors.textFourth,
      fill: theme.colors.textFourth,
      '&:after': {
        opacity: 1,
        transform: 'translateY(0)',
      },
    }}

  margin-right: 30px;
  margin-left: 0;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.textThird};
  fill: currentColor;

  svg {
    margin-right: 7px;
    max-width: 16px;
  }

  &:last-of-type {
    margin-right: 0;
  }
`
